import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http' 
import { oneAssetApi } from '../constants/constants'

@Injectable({
  providedIn: 'root'
})
export class PerformanceCalculationService {

  private _performanceCalUrl:string = oneAssetApi + "/Performance/Summary";

  constructor(private http: HttpClient) { }

  getPerformanceSum(fundId, date) {
    let _body:object = {fundId: fundId, date: date}
    return this.http.post(this._performanceCalUrl,_body)
  }
}
